// src/services/materialHistoryService.js
import { getToken, getUserId } from '../utils/secureStorage';

const getAuthHeaders = () => {
  const token = getToken();
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

export const materialHistoryService = {
  // ثبت وضعیت مشاهده یا دانلود
  async track(materialId, type, status) {
    try {
      const userId = getUserId();
      if (!userId) return false;

      const res = await fetch('/api/secure-jozwe/track', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...getAuthHeaders()
        },
        body: JSON.stringify({ materialId, type, status })
      });
      return res.ok;
    } catch (e) {
      console.warn('⚠️ تاریخچه ثبت نشد:', e);
      return false;
    }
  },

  // خواندن تاریخچه کاربر
  async getHistory() {
    try {
      const userId = getUserId();
      if (!userId) return [];

      const res = await fetch(`/api/db/userMaterialHistory?userId=${userId}`, {
        headers: getAuthHeaders()
      });
      if (!res.ok) return [];
      const data = await res.json();
      if (!Array.isArray(data)) return [];

      // 🆕 Deduplicate بر اساس materialId (نگه‌داشتن جدیدترین رکورد)
      const map = new Map();
      data.forEach(item => {
        const existing = map.get(item.materialId);
        if (!existing) {
          map.set(item.materialId, item);
        } else {
          const existingTime = new Date(existing.updatedAt || 0).getTime();
          const newTime = new Date(item.updatedAt || 0).getTime();
          if (newTime > existingTime) map.set(item.materialId, item);
        }
      });
      return Array.from(map.values());
    } catch (e) {
      console.warn('⚠️ تاریخچه خوانده نشد:', e);
      return [];
    }
  }
};